import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "news-detail" }

import { onMounted, onUnmounted } from 'vue'
import { getCommonElementById, getStaticHtml, getOssUrls } from '@/api'
import { useStore } from 'vuex'
import { findSequences, findSequences2 } from '@/utils'
import router from '@/router'


export default /*@__PURE__*/_defineComponent({
  __name: 'CaseDetail',
  setup(__props) {

const store = useStore()

// 返回处理函数：设置标记，告诉返回页面不要滚动到顶部
const handleBack = () => {
  // 设置标记，表示这次返回不需要滚动到顶部
  window.sessionStorage.setItem('keepScrollPosition', 'true');
  router.back();
}

onMounted(() => {
  if (document.documentElement && document.documentElement.scrollTop) {
    document.documentElement.scrollTop = 0;
  } else if (document.body) {
    document.body.scrollTop = 0
  }
  const path: any = JSON.parse(window.sessionStorage.getItem('path') || '{}');
  if (path.query?.htmlId) {
    getStaticHtml({ id: path.query?.htmlId }).then((html: any) => {
      const resultKeys = findSequences(html);
      const resultSources = findSequences2(html);
      getOssUrls(resultKeys).then((res: any) => {
        resultKeys.forEach((urlKey, i) => {
          html = html.replace(resultSources[i], `source src="${res[i]}`)
        });
        (document.querySelector('.news-detail div') as any).innerHTML = html
      })
    })
    return
  }
  getCommonElementById({ id: path.query?.id }).then((res: any) => {
    if (res.relatedHtmlId) {
      getStaticHtml({ id: res.relatedHtmlId }).then((html: any) => {
        const resultKeys = findSequences(html);
        const resultSources = findSequences2(html);
        getOssUrls(resultKeys).then((res: any) => {
          resultKeys.forEach((urlKey, i) => {
            html = html.replace(resultSources[i], `source src="${res[i]}`)
          });
          (document.querySelector('.news-detail div') as any).innerHTML = html
        })
      })
    }
  })
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "back-btn",
      onClick: handleBack
    }, "返回"),
    _cache[0] || (_cache[0] = _createElementVNode("div", null, null, -1))
  ]))
}
}

})